<template>
  <div class="__InfoWall" :style="{ height: height }">
    <CLoading :loading="loading" v-if="loading" />
    <div v-else>
      <CIcon :name="icon" :material="materialIcon" class="icon" />
      <p>{{ message }}</p>
    </div>
  </div>
</template>

<script>
import CLoading from '@/components/uikit/CLoading';
import CIcon from '@/components/uikit/CIcon';

export default {
  name: 'InfoWall',
  components: { CLoading, CIcon },
  props: {
    icon: {
      type: String,
      default: 'fas fa-info-circle',
    },
    materialIcon: {
      type: Boolean,
    },
    message: {
      type: String,
      default: 'Error',
    },
    height: {
      type: String,
      default: '600px',
    },
    loading: Boolean,
  },
};
</script>

<style lang="scss" scoped>
.__InfoWall {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 50%;
  text-align: center;

  .icon {
    font-size: 10em;
    color: $neutral-secondary-color;
  }

  p {
    text-align: center;
    color: $neutral-secondary-color;
    font-size: 1.5em;
  }
}
</style>
